import React from 'react';
import { Box, Flex, IconButton } from '@radix-ui/themes';
import { CardStackPlusIcon } from '@radix-ui/react-icons';

export default function Footer() {
  return (
    <Flex
      asChild
      justify="between"
      align="center"
      px="4"
      py="1"
      style={{
        backgroundImage: `
      radial-gradient(
        circle at top left,
        color-mix(in srgb, var(--amber-glow) 42%, transparent),
        transparent 36%
      ),
      linear-gradient(180deg, rgba(255, 255, 255, 0.2), transparent 65%)
    `,
      }} /* todo: refactor and improve top bar. */
    >
      <footer>
        <Box style={{ width: 40, height: 40 }}>
          <img
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            src="/icons/icon.svg"
          />
        </Box>
        <IconButton variant="surface">
          <CardStackPlusIcon width="18" height="18" />
        </IconButton>
      </footer>
    </Flex>
  );
}
